import { render } from "./MyNav.vue?vue&type=template&id=6943502a&scoped=true"
import script from "./MyNav.vue?vue&type=script&lang=js"
export * from "./MyNav.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/7e868b86-35b8-4c8b-aa8f-81c8fe9154a3/work/Илюха/texuspex.ru/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6943502a"]])

export default __exports__